import { render, staticRenderFns } from "./PolicyRenewalInfo.vue?vue&type=template&id=4ba966d9&"
import script from "./PolicyRenewalInfo.vue?vue&type=script&lang=js&"
export * from "./PolicyRenewalInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports